import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Language } from '../../types';
import i18n from '../../i18n';

interface LanguageState {
  current: Language;
  initialized: boolean;
}

const initialState: LanguageState = {
  current: Language.FR,
  initialized: false,
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.current = action.payload;
      i18n.changeLanguage(action.payload);
      localStorage.setItem('language', action.payload);
    },
    initializeLanguage: (state) => {
      const savedLanguage = localStorage.getItem('language');
      if (savedLanguage && Object.values(Language).includes(savedLanguage as Language)) {
        state.current = savedLanguage as Language;
        i18n.changeLanguage(savedLanguage);
      }
      state.initialized = true;
    },
  },
});

export const { setLanguage, initializeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
